import apiClient from "@/api/client";
import type { SmsLogEntry, SmsLogStatus, SmsOccasion } from "../types";

export const SMS_LOG_PAGE_SIZE = 25;

export interface SmsLogParams {
  search?: string;
  occasion?: string;
  status?: SmsLogStatus | "";
  date_from?: string;
  date_to?: string;
  page?: number;
  page_size?: number;
}

export interface SmsLogResult {
  data: SmsLogEntry[];
  count: number;
}

export const smsLogApi = {
  list: (params?: SmsLogParams): Promise<SmsLogResult> =>
    apiClient
      .get("/sms/log/", { params: { page_size: SMS_LOG_PAGE_SIZE, ...params } })
      .then((r) => ({
        data: r.data.data as SmsLogEntry[],
        count: (r.data.meta?.count as number) ?? 0,
      })),

  occasions: (): Promise<SmsOccasion[]> =>
    apiClient.get("/sms/log/occasions/").then((r) => r.data.data as SmsOccasion[]),
};
